import config from "./config.js";
import React, { useEffect, useState } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Logout from "./components/Logout";
import UserManagement_Users from "./components/UserManagement_Users";
import UserManagement_CreateUserGroup from "./components/UserManagement_CreateUserGroup";
import UserManagement_CreateDashboardGroup from "./components/UserManagement_CreateDashboardGroup";
import HTTPSources from "./components/HTTPSources";
import MQTTSources from "./components/MQTTSources";
import Reports from "./components/Reports";
import Alarms from "./components/Alarms";
import Alarms_Create from "./components/Alarms_Create";
import Alarms_Edit from "./components/Alarms_Edit";
import Alarms_Delete from "./components/Alarms_Delete";
import Settings from "./components/Settings";
import Views from "./components/Views";
import Views_Create from "./components/Views_Create";
import Views_Edit from "./components/Views_Edit";
import Views_Delete from "./components/Views_Delete";
import NotFoundPage from "./components/NotFoundPage";
import EventLog from "./components/EventLog";
import SetLoginCookies from "./components/SetLoginCookies";
import ProtectedRoute from "./components/ProtectedRoute";
import Axios from "axios";
import Permissions from "./components/Permissions";
import PermissionsCreate from "./components/PermissionsCreate";
import PermissionsAssign from "./components/PermissionsAssign";
import PermissionDelete from "./components/PermissionDelete";
import PermissionsEdit from "./components/PermissionsEdit";
import SuperUserPage from "./components/SuperuserPage";
import UserProfile from "./components/UserProfile";
import Inviteform from "./components/Inviteform";
import RegisterUser from "./components/RegisterUser";
import ResetPassword from "./components/ResetPassword";
import mixpanel from "mixpanel-browser";
import "./fonts.css";

// Secure config file for sensitive data (assumed to exist)
import secureConfig from "./secureConfig.json";
function App() {
  const [superuserCreated, setSuperuserCreated] = useState(false);

  // Check and create superuser only if it doesn’t exist
  useEffect(() => {
    Axios.get(config.BACKEND_URL + "/superuser/check")
      .then((res) => {
        if (!res.data.exists) {
          // Create superuser if it doesn’t exist
          Axios.post(config.BACKEND_URL + "/superuser/create", {
            username: secureConfig.superuser.username,
            password: secureConfig.superuser.password,
            fullname: secureConfig.superuser.fullname,
            email: secureConfig.superuser.email,
            contact: secureConfig.superuser.contact,
          })
            .then(() => {
              setSuperuserCreated(true);
              //console.log("Superuser created successfully.");
            })
            .catch((err) => {
              console.error("Error creating superuser:", err);
            });
        } else {
          setSuperuserCreated(true);
          //console.log("Superuser already exists.");
        }
      })
      .catch((err) => {
        console.error("Error checking superuser:", err);
      });
  }, []);

  // Initialize Mixpanel once when the app mounts
  useEffect(() => {
    mixpanel.init("25a6b37960a514f6e707c9c25ca300af", { debug: true });
  }, []);

  return (
    // <>
    //   <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
    //   <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap" rel="stylesheet" />
    //   <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />
    //   <Routes>

    //     <Route exact path="/" component={Login} />
    //     <Route path="/set-login-cookies" component={SetLoginCookies} />
    //     <Route exact path="/register-user/:token" component={RegisterUser} />
    //     <Route exact path="/reset-password/:token" component={ResetPassword} />
    //     <Route path="/logout" component={Logout} />

    //     <ProtectedRoute path="/dashboard" component={Dashboard} />
    //     <ProtectedRoute exact path="/user_management" component={UserManagement_Users} />
    //     <ProtectedRoute path="/user_management/users" component={UserManagement_Users} />
    //     <ProtectedRoute path="/user_management/user_groups" component={UserManagement_CreateUserGroup} />
    //     <ProtectedRoute path="/user_management/dashboard_groups" component={UserManagement_CreateDashboardGroup} />
    //     <ProtectedRoute path="/sensor_settings" component={Settings} />
    //     <ProtectedRoute path="/http_sources" component={HTTPSources} />
    //     <ProtectedRoute path="/mqtt_sources" component={MQTTSources} />
    //     <ProtectedRoute path="/reports" component={Reports} />
    //     <ProtectedRoute path="/EventLog" component={EventLog} />
    //     <ProtectedRoute exact path="/views" component={Views} />
    //     <ProtectedRoute path="/views/create" component={Views_Create} />
    //     <ProtectedRoute path="/views/edit" component={Views_Edit} />
    //     <ProtectedRoute path="/views/delete" component={Views_Delete} />
    //     <ProtectedRoute exact path="/alarms" component={Alarms} />
    //     <ProtectedRoute path="/alarms/create" component={Alarms_Create} />
    //     <ProtectedRoute path="/alarms/edit" component={Alarms_Edit} />
    //     <ProtectedRoute path="/alarms/delete" component={Alarms_Delete} />
    //     <ProtectedRoute path="/permissions/create" component={PermissionsCreate} />
    //     <ProtectedRoute path="/permissions/edit" component={PermissionsEdit} />
    //     <ProtectedRoute path="/permissions/delete" component={PermissionDelete} />
    //     <ProtectedRoute path="/permissions/assign" component={PermissionsAssign} />
    //     <ProtectedRoute exact path="/user-profile" component={UserProfile} />
    //     <ProtectedRoute exact path="/superuser" component={SuperUserPage} />
    //     <ProtectedRoute path="/invite-user" component={Inviteform} />

    //     <Route component={NotFoundPage} />
    //   </Routes>
    // </>

    <>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/set-login-cookies" element={<SetLoginCookies />} />
        <Route path="/register-user/:token" element={<RegisterUser />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/logout" element={<Logout />} />

        {/* Protected Routes Wrapper */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/user_management" element={<UserManagement_Users />} />
          <Route
            path="/user_management/users"
            element={<UserManagement_Users />}
          />
          <Route
            path="/user_management/user_groups"
            element={<UserManagement_CreateUserGroup />}
          />
          <Route
            path="/user_management/dashboard_groups"
            element={<UserManagement_CreateDashboardGroup />}
          />
          <Route path="/sensor_settings" element={<Settings />} />
          <Route path="/http_sources" element={<HTTPSources />} />
          <Route path="/mqtt_sources" element={<MQTTSources />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/EventLog" element={<EventLog />} />
          <Route path="/views" element={<Views />} />
          <Route path="/views/create" element={<Views_Create />} />
          <Route path="/views/edit" element={<Views_Edit />} />
          <Route path="/views/delete" element={<Views_Delete />} />
          <Route path="/alarms" element={<Alarms />} />
          <Route path="/alarms/create" element={<Alarms_Create />} />
          <Route path="/alarms/edit" element={<Alarms_Edit />} />
          <Route path="/alarms/delete" element={<Alarms_Delete />} />
          <Route path="/permissions/create" element={<PermissionsCreate />} />
          <Route path="/permissions/edit" element={<PermissionsEdit />} />
          <Route path="/permissions/delete" element={<PermissionDelete />} />
          <Route path="/permissions/assign" element={<PermissionsAssign />} />
          <Route path="/user-profile" element={<UserProfile />} />
          <Route path="/superuser" element={<SuperUserPage />} />
          <Route path="/invite-user" element={<Inviteform />} />
        </Route>

        {/* Fallback Route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
